export enum ACCOUNT_AVAILABILITY_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
